<template>
    <!-- Aviso de documentos em atraso: so fecha com a confirmacao, que fica na auditoria. -->
    <v-dialog :value="open" max-width="640" persistent scrollable>
        <v-card class="overdue-notice">
            <v-card-title class="overdue-notice__title">
                <v-icon color="error" class="mr-2">mdi-alert-circle-outline</v-icon>
                Documentos em atraso
            </v-card-title>
            <v-card-text>
                <p class="overdue-notice__message">{{ notice.message }}</p>
                <p class="overdue-notice__hint">
                    Envie os documentos pendentes ou registre uma justificativa. A Administração Judicial acompanha os atrasos.
                </p>
                <div class="overdue-notice__list">
                    <div v-for="item in notice.items" :key="item.key" class="overdue-notice__item">
                        <div class="overdue-notice__item-title">{{ item.title }}</div>
                        <div class="overdue-notice__item-sub">
                            <span v-if="item.since">Em atraso desde {{ formatDay(item.since) }} · </span>
                            prazo era {{ formatDay(item.deadline) }}
                            <span v-if="item.pending_count"> · {{ item.pending_count }} documento(s) pendente(s)</span>
                        </div>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions class="overdue-notice__actions">
                <v-btn text color="primary" :disabled="saving" @click="confirm(targetRoute)">Ver documentos</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" depressed :loading="saving" @click="confirm()">OK, estou ciente</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";

export default {
    name: "OverdueNoticeDialog",

    data: () => ({
        open: false,
        saving: false,
        notice: { message: "", items: [] },
    }),

    computed: {
        // Primeiro item em atraso define para onde "Ver documentos" leva.
        targetRoute() {
            const first = (this.notice.items || [])[0];
            if (first && first.kind === "rma") return first.track === "legal" ? "/juridico" : "/fiscalizacao-mensal";
            return "/documentos-solicitados";
        },
    },

    created() {
        this.load();
    },

    methods: {
        async load() {
            try {
                const result = await axios.get("/api/client/overdue-notice");
                const content = result.data.content || {};
                this.notice = { message: content.message || "", items: content.items || [] };
                this.open = !!content.pending && this.notice.items.length > 0;
            } catch (error) {
                // O aviso nao pode travar o painel: sem resposta, ele nao aparece.
                this.open = false;
            }
        },

        formatDay(value) {
            if (!value) return "";
            const [year, month, day] = String(value).slice(0, 10).split("-");
            return `${day}/${month}/${year}`;
        },

        async confirm(route = null) {
            this.saving = true;
            try {
                await axios.post("/api/client/overdue-notice/ack");
                this.open = false;
                if (route && this.$route.path !== route) this.$router.push(route);
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 4000 });
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>

<style scoped>
.overdue-notice__title { font-size: 18px; font-weight: 600; word-break: normal; }
.overdue-notice__message { font-size: 15px; font-weight: 600; color: #b42318; margin-bottom: 8px; }
.overdue-notice__hint { font-size: 13px; color: #5f5a6b; margin-bottom: 12px; }
.overdue-notice__list { display: flex; flex-direction: column; gap: 8px; }
.overdue-notice__item { padding: 10px 12px; border: 1px solid #f1d4d2; border-radius: 8px; background: #fff8f7; }
.overdue-notice__item-title { font-size: 14px; font-weight: 600; color: #1d0b33; }
.overdue-notice__item-sub { font-size: 12.5px; color: #5f5a6b; margin-top: 2px; }
.overdue-notice__actions { padding: 12px 16px; }
</style>
